import { SimType } from '../services/simService';

/**
 * แปลงประเภทซิมจากภาษาอังกฤษเป็นภาษาไทย
 * @param simType - ประเภทซิม (PREPAID, POSTPAID, YEARLY, CORPORATE, OTHER)
 * @returns ชื่อประเภทซิมเป็นภาษาไทย
 */
export const getSimTypeLabel = (simType: SimType | string): string => {
  const labels: Record<string, string> = {
    'PREPAID': 'เติมเงิน',
    'POSTPAID': 'รายเดือน',
    'YEARLY': 'รายปี',
    'CORPORATE': 'องค์กร',
    'OTHER': 'อื่นๆ'
  };
  
  return labels[simType] || simType;
};

/**
 * แปลงสถานะซิมจากภาษาอังกฤษเป็นภาษาไทย
 * @param status - สถานะซิม
 * @returns ชื่อสถานะซิมเป็นภาษาไทย
 */
export const getSimStatusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    'AVAILABLE': 'พร้อมใช้งาน',
    'IN_USE': 'กำลังใช้งาน',
    'ACTIVE': 'ใช้งานอยู่',
    'INACTIVE': 'ไม่ได้ใช้งาน',
    'SUSPENDED': 'ระงับการใช้งาน',
    'EXPIRED': 'หมดอายุ',
    // ใบงานเตรียมเครื่อง (PO 2026-09-08) — ตรงกับ backend `SIM_STATUS_TH['RESERVED']`
    'RESERVED': 'จองไว้ (ใบงานเตรียมเครื่อง)',
    // ยืมซิมตามใบเบิก-ยืม (23 ก.ย. 2026) — คำเดียวกับอุปกรณ์ ISSUED
    'ISSUED': 'เบิกไปใช้ภายใน'
  };

  return labels[status] || status;
};

/**
 * แปลงชื่อค่ายมือถือให้เป็นชื่อเต็ม
 * @param operator - ชื่อค่าย (AIS, TRUE, DTAC)
 * @returns ชื่อเต็มของค่าย
 */
export const getOperatorFullName = (operator: string): string => {
  const names: Record<string, string> = {
    'AIS': 'AIS',
    'TRUE': 'True',
    'DTAC': 'DTAC',
    'NT': 'NT',
    'CAT': 'CAT',
    'TOT': 'TOT'
  };
  
  return names[operator?.toUpperCase()] || operator;
};